import { default as state } from '@/store/modules/app/state'
import { FileType } from '@/store/types'

export default {

  /**
   * Retrieves an array of allowed file extensions based on `dynaconfConfig`.
   * The result is a flattened array of file extensions.
   *
   * @returns { string[] } An array of allowed file extensions.
   */
  allowedModelFileFormats(): string[] {
    return state.dynaconfConfig.fileformats.fileTypes
      .filter((f: FileType) => f.enabled && f.uploadType === '3D Models')
      .map((f: FileType) => f.extensions)
      .flat()
  },
}
